var _rect, _path, _path2, _path3, _ellipse, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 60,
    viewBox: "0 0 289 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_2527_9338)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2527_9338)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 285,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_2527_9338)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.182 44.9459H44.7639C44.7639 41.5359 43.4886 38.5545 40.94 36.0059C38.3915 33.4573 35.4122 32.182 32 32.182V31.7639C35.4122 31.7639 38.3915 30.4886 40.94 27.9337C43.4886 25.3788 44.7639 22.3995 44.7639 19H45.182C45.182 22.4101 46.4574 25.3915 49.0059 27.94C51.5545 30.4886 54.5338 31.7639 57.9459 31.7639V32.182C54.5359 32.182 51.5545 33.4573 49.0059 36.0059C46.4574 38.5545 45.182 41.5338 45.182 44.9459Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8778 30.6757H63.6897C63.6897 29.1412 63.1158 27.7995 61.9689 26.6527C60.8221 25.5058 59.4814 24.9319 57.9459 24.9319V24.7438C59.4814 24.7438 60.8221 24.1699 61.9689 23.0202C63.1158 21.8705 63.6897 20.5298 63.6897 19H63.8778C63.8778 20.5345 64.4517 21.8762 65.5986 23.023C66.7454 24.1699 68.0861 24.7438 69.6216 24.7438V24.9319C68.0871 24.9319 66.7454 25.5058 65.5986 26.6527C64.4517 27.7995 63.8778 29.1402 63.8778 30.6757Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.28 37H74.24L79.52 22.54H81.7L87 37H84.94L83.64 33.4H77.56L76.28 37ZM80.36 25.66L78.16 31.7H83.06L80.84 25.66C80.74 25.38 80.64 25.04 80.6 24.82C80.56 25.02 80.46 25.36 80.36 25.66ZM90.2822 37H88.4022V27.22H90.0822L90.2622 28.5C90.7622 27.58 91.8022 26.94 93.1822 26.94C94.7022 26.94 95.7822 27.7 96.2822 28.92C96.7422 27.7 97.9222 26.94 99.4422 26.94C101.682 26.94 103.042 28.34 103.042 30.6V37H101.202V31.06C101.202 29.52 100.342 28.64 99.0222 28.64C97.6022 28.64 96.6622 29.64 96.6622 31.2V37H94.8022V31.04C94.8022 29.5 93.9622 28.66 92.6422 28.66C91.2222 28.66 90.2822 29.64 90.2822 31.2V37ZM105.448 41.38V27.22H107.148L107.288 28.98C107.948 27.64 109.268 26.94 110.828 26.94C113.628 26.94 115.368 29.04 115.368 32.04C115.368 35.02 113.728 37.26 110.828 37.26C109.268 37.26 107.968 36.6 107.328 35.4V41.38H105.448ZM107.348 32.12C107.348 34.12 108.508 35.56 110.428 35.56C112.348 35.56 113.488 34.12 113.488 32.12C113.488 30.1 112.348 28.66 110.428 28.66C108.508 28.66 107.348 30.08 107.348 32.12ZM119.16 37H117.28V22.28H119.16V37ZM122.648 24.9C121.968 24.9 121.408 24.34 121.408 23.66C121.408 22.96 121.968 22.42 122.648 22.42C123.328 22.42 123.888 22.96 123.888 23.66C123.888 24.34 123.328 24.9 122.648 24.9ZM121.728 37V27.22H123.608V37H121.728ZM125.097 27.22H126.537V25.66C126.537 23.26 127.857 22.28 129.637 22.28C129.997 22.28 130.417 22.3 130.797 22.36V23.98H129.957C128.737 23.98 128.417 24.6 128.417 25.66V27.22H130.737V28.8H128.417V37H126.537V28.8H125.097V27.22ZM131.345 41.38V39.84H132.605C133.505 39.84 134.225 39.7 134.685 38.46L135.025 37.52L131.085 27.22H133.065L135.905 35.1L138.805 27.22H140.745L136.125 39.2C135.465 40.88 134.485 41.58 132.985 41.58C132.365 41.58 131.845 41.5 131.345 41.38ZM151.055 31.12L146.155 22.54H148.355L151.575 28.32C151.775 28.66 151.895 28.94 152.055 29.28C152.235 28.92 152.275 28.8 152.535 28.32L155.735 22.54H157.875L153.015 31.12V37H151.055V31.12ZM156.631 32.1C156.631 29.08 158.791 26.96 161.731 26.96C164.651 26.96 166.811 29.08 166.811 32.1C166.811 35.12 164.651 37.24 161.731 37.24C158.791 37.24 156.631 35.12 156.631 32.1ZM158.531 32.1C158.531 34.14 159.831 35.56 161.731 35.56C163.611 35.56 164.931 34.14 164.931 32.1C164.931 30.06 163.611 28.64 161.731 28.64C159.831 28.64 158.531 30.06 158.531 32.1ZM175.218 27.22H177.078V37H175.398L175.198 35.52C174.638 36.54 173.338 37.24 171.898 37.24C169.618 37.24 168.338 35.7 168.338 33.3V27.22H170.218V32.68C170.218 34.78 171.118 35.58 172.558 35.58C174.278 35.58 175.218 34.48 175.218 32.38V27.22ZM185.205 27.14V28.86H184.365C182.585 28.86 181.485 29.94 181.485 31.82V37H179.605V27.24H181.365L181.485 28.72C181.885 27.7 182.865 27.02 184.205 27.02C184.545 27.02 184.825 27.06 185.205 27.14ZM192.957 37H190.917L196.197 22.54H198.377L203.677 37H201.617L200.317 33.4H194.237L192.957 37ZM197.037 25.66L194.837 31.7H199.737L197.517 25.66C197.417 25.38 197.317 25.04 197.277 24.82C197.237 25.02 197.137 25.36 197.037 25.66ZM204.284 31.86C204.284 29.1 206.064 26.94 208.904 26.94C210.484 26.94 211.704 27.66 212.324 28.88L212.464 27.22H214.144V36.6C214.144 39.68 212.244 41.64 209.244 41.64C206.584 41.64 204.764 40.14 204.404 37.66H206.284C206.524 39.1 207.604 39.94 209.244 39.94C211.084 39.94 212.284 38.74 212.284 36.88V34.92C211.644 36.06 210.364 36.74 208.824 36.74C206.044 36.74 204.284 34.6 204.284 31.86ZM206.164 31.82C206.164 33.66 207.304 35.1 209.144 35.1C211.044 35.1 212.204 33.74 212.204 31.82C212.204 29.94 211.084 28.58 209.164 28.58C207.284 28.58 206.164 30.02 206.164 31.82ZM220.877 37.24C217.997 37.24 216.017 35.16 216.017 32.12C216.017 29.06 217.957 26.94 220.797 26.94C223.577 26.94 225.397 28.86 225.397 31.76V32.46L217.837 32.48C217.977 34.54 219.057 35.68 220.917 35.68C222.377 35.68 223.337 35.08 223.657 33.96H225.417C224.937 36.06 223.297 37.24 220.877 37.24ZM220.797 28.52C219.157 28.52 218.117 29.5 217.877 31.22H223.517C223.517 29.6 222.457 28.52 220.797 28.52ZM229.177 37H227.297V27.22H228.997L229.197 28.72C229.817 27.6 231.057 26.94 232.437 26.94C235.017 26.94 236.197 28.52 236.197 31.02V37H234.317V31.44C234.317 29.46 233.397 28.66 231.957 28.66C230.197 28.66 229.177 29.92 229.177 31.82V37ZM237.961 32.12C237.961 29.06 239.901 26.94 242.761 26.94C245.221 26.94 246.941 28.34 247.281 30.52H245.401C245.081 29.28 244.081 28.62 242.821 28.62C241.041 28.62 239.821 29.98 239.821 32.1C239.821 34.2 240.961 35.56 242.741 35.56C244.081 35.56 245.081 34.86 245.421 33.7H247.301C246.921 35.82 245.101 37.24 242.741 37.24C239.861 37.24 237.961 35.2 237.961 32.12ZM247.949 41.38V39.84H249.209C250.109 39.84 250.829 39.7 251.289 38.46L251.629 37.52L247.689 27.22H249.669L252.509 35.1L255.409 27.22H257.349L252.729 39.2C252.069 40.88 251.089 41.58 249.589 41.58C248.969 41.58 248.449 41.5 247.949 41.38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_2527_9338)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.735,
    cy: 49.3511,
    rx: 55.1351,
    ry: 4.54054,
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35135,
    y: 1.35135,
    width: 286.297,
    height: 57.2973,
    rx: 28.6486,
    stroke: "url(#paint1_linear_2527_9338)",
    strokeOpacity: 0.08,
    strokeWidth: 1.2973
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_2527_9338",
    x: 0.702759,
    y: -30.4324,
    width: 287.595,
    height: 100.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20.7568,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2527_9338"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3784
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_2527_9338"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -31.1351
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.7568
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2527_9338",
    result: "effect2_innerShadow_2527_9338"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78378
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2527_9338",
    result: "effect3_innerShadow_2527_9338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2527_9338",
    x: 73.7347,
    y: 27.9457,
    width: 144,
    height: 42.8108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.43243,
    result: "effect1_foregroundBlur_2527_9338"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2527_9338",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.5 30) scale(142.5 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A083F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27009D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2527_9338",
    x1: 2,
    y1: 30,
    x2: 287,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250099"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2527_9338"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 285,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplify);
export default __webpack_public_path__ + "static/media/Amplify.12e2625bf62ae1338577f948a272e135.svg";
export { ForwardRef as ReactComponent };